/**
 * Z-index layer policy for overlays across the app.
 *
 * Layering order (low → high):
 *   NORMAL_MODAL  — Ant Design Modal default, applies to all regular popups via theme
 *   BOTTOM_SHEET  — Drawer/BottomSheet that must overlay a normal modal
 *   ERROR_MODAL   — Error popup only; must always sit above every other layer
 */
export const MODAL_LAYER_Z_INDEX = {
  NORMAL_MODAL: 1000,
  BOTTOM_SHEET: 1100,
  ERROR_MODAL: 2000,
};
